/**
 * @file zt-icon图标
 */
import loading from './loading.icon';
import warning from './warning.icon';
import edit from './edit.icon';
import circlePlus from './circle-plus.icon';
import deleteIcon from './delete.icon';
import arrowDown from './arrow-down.icon';
import dataMonitor from './data-monitor.icon';
import strategy from './strategy.icon';
import access from './access.icon';
import infoSearch from './info-search.icon';
import calendar from './calendar.icon';
import info from './info.icon';
import plusSquare from './plus-square.icon';
import dataReport from './data-report.icon';
import time from './time.icon';
import close from './close.icon';
import right from './right.icon';
import logReport from './log-report.icon';
import search from './search.icon';
import noData from './no-data.icon';
import circleClose from './circle-close.icon';
import intelligence from './intelligence.icon';
import situation from './situation.icon';
import intervene from './intervene.icon';
import dock from './dock.icon';
import arrowDownLine from './arrow-down-line.icon';
import arrowUpLine from './arrow-up-line.icon';
import docs from './docs.icon';
import analyse from './analyse.icon';

export default {
    loading,
    warning,
    edit,
    delete: deleteIcon,
    'circle-plus': circlePlus,
    'arrow-down': arrowDown,
    'data-monitor': dataMonitor,
    strategy,
    access,
    'info-search': infoSearch,
    calendar,
    info,
    'plus-square': plusSquare,
    'data-report': dataReport,
    time,
    close,
    'circle-close': circleClose,
    right,
    'log-report': logReport,
    search,
    'no-data': noData,
    intelligence,
    situation,
    intervene,
    dock,
    'arrow-down-line': arrowDownLine,
    'arrow-up-line': arrowUpLine,
    docs,
    analyse
};